module.exports = __webpack_public_path__ + "static/media/Madeleine Bouton.5798675f.jpeg";